import React, { Fragment } from 'react';
import { Stack, Grid, InputAdornment, IconButton, Box } from '@mui/material';
import { StyledCard, StyledCardTitle, CustomInputLabel, CustomDatePicker, CustomSearch, InputProps, FlexDiv, } from '../../../../../custom/components';
import styles from '../../../../../custom/style.module.css';
import docStyles from './otherdoc.module.css';
import { AttachFile as AttachFileIcon, Search } from '@mui/icons-material';
import dayjs from 'dayjs';
import AttachmentContainer from '../attachment/AttachmentContainer';
import moment from 'moment';
import TableWrapper from 'components/pages/common/TanStackTableWrapper';

const OtherDoc = (props) => {
  const columns = [
    {
      accessorKey: 'type',
      header: 'Type',
      size: 100,
      cell: info => {
        const row = info.row.original;
        return row?.sub_type == 'AWB'
          ? 'Airwaybill'
          : row?.sub_type == 'FLIGHT'
            ? 'Flight'
            : 'Other';
      },
    },
    {
      accessorKey: 'name',
      header: 'Name',
      size: 100,
      cell: info => info.getValue(),
    },
    {
      accessorKey: 'sub_type',
      header: 'Attached To',
      size: 80,
      cell: info => {
        const row = info.row.original;
        if (row?.sub_type == 'AWB') {
          return row?.awb ? `${row.awb.code}-${row.awb.number}` : '';
        } else if (row?.sub_type == 'FLIGHT') {
          return (
            row?.flight?.airline?.code +
          row?.flight?.flight_no +
          '/' +
          moment(row?.flight?.flight_date).format('DDMMMYY')
          );
        } else {
          return row?.data?.ref || row?.name;
        }
      },
    },
    {
      id: 'action',
      header: <div className={`${styles.textCenter}`}>Action</div>,
      size: 100,
      enableSorting: false,
      enableColumnFilter: false,
      cell: info => {
        const row = info.row.original;
        return (
          <Stack
            direction='row'
            spacing={2}
            justifyContent='center'
            className={styles.actionIcons}
          >
            <div onClick={() => props.handlePopover('attached_docs', row)}>
              <AttachFileIcon
                fontSize='small'
                className={`${styles.pointer}`}
              />
            </div>
          </Stack>
        );
      },
    },
  ];

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StyledCard>
            <FlexDiv><StyledCardTitle>Filter Other Documents List</StyledCardTitle></FlexDiv>
            <Stack direction='row' alignItems={'center'} justifyContent='flex-end' mt={'-16px'}>
              <CustomSearch
                id='search'
                type='search'
                placeholder='AWB Number | Flight Number | Other'
                name='search'
                className={`${styles.brInput} ${styles.width245}`}
                value={props.searchOptions.search}
                onChange={(e) => props.handleChange(e, 'search')}
                InputProps={{
                  classes: { input: styles.pr0 },
                  endAdornment: <InputAdornment position='end'>
                    <IconButton
                      size='small'
                      aria-label='search'
                      edge='end'
                      onClick={props.search}
                    >
                      <Search fontSize='inherit' />
                    </IconButton>
                  </InputAdornment>,
                }}
                onKeyDown={
                  (e) => {
                    if (e.key === 'Enter') {
                      props.search(true);
                    }
                  }
                }
              />
            </Stack>
      
            <Grid container spacing={2} columnSpacing={4}>
              <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
                <CustomInputLabel htmlFor='' aria-label='Enter from date'>From</CustomInputLabel>
                <CustomDatePicker
                  slotProps={{
                    textField: {
                      ...InputProps,
                      placeholder: 'From Date',
                      fullWidth: true
                    },
                  }}
                  className={styles.w100}
                  format='DD MMM YYYY'
                  name='from'
                  value={dayjs(props.searchOptions.from)}
                  // helperText={}
                  onChange={(e) => props.handleChange(e, 'from')}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
                <CustomInputLabel htmlFor='' aria-label='Enter to date '>To</CustomInputLabel>
                <CustomDatePicker
                  slotProps={{
                    textField: {
                      ...InputProps,
                      placeholder: 'To Date',
                      fullWidth: true
                    },
                  }}
                  className={styles.w100}
                  format='DD MMM YYYY'
                  name='to'
                  value={dayjs(props.searchOptions.to)}
                  // helperText={}
                  onChange={(e) => props.handleChange(e, 'to')}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={8} className={styles.sqIconsContainer}>
                <CustomInputLabel className={styles.colorTransparent}>-</CustomInputLabel>
                <IconButton disableRipple onClick={() => props.search()} className={styles.p0}>
                  <Search fontSize='1.7rem' classes={{ root: `${styles.sqIcons} ${styles.mb0}` }} />
                </IconButton>
              </Grid>
            </Grid>
          </StyledCard>
        </Grid>

        <Grid item xs={12}>
          <StyledCard className={styles.positionRelative}>
            <FlexDiv className={styles.mb4}><StyledCardTitle>Other Documents</StyledCardTitle></FlexDiv>
            {/* <CustomSearch
                id='search'
                name='awb'
                value={props.filter.awb}
                variant='outlined'
                size='small'
                placeholder='Enter Name'
                onChange={props.onChangefilter}
                type='search'
                className={styles.brInput}
                InputProps={{
                  endAdornment: <InputAdornment position='end'>
                    <IconButton
                      size='small'
                      aria-label='search'
                      edge='end'
                      onClick={() => props.onChangefilter({
                        target: {
                          name: 'awb_search',
                          value: ''
                        }
                      })}
                    >
                      <Search fontSize='inherit' />
                    </IconButton>
                  </InputAdornment>,
                }}
                InputLabelProps={{ shrink: false }}
              /> */}
            <div className={styles.tableWrapper}>
              <Box className={`${styles.tableOuter} ${docStyles.docTableOuter}`}>
                <TableWrapper columns={columns} data={props.data} />
              </Box>
            </div>
          </StyledCard>
        </Grid>

      </Grid>
      {props.modal === 'attached_docs' &&
        <AttachmentContainer
          handlePopover={props.handlePopover}
          modal={props.modal}
          type={'OTHER'}
          docs={props.docs}
        />}
    </>
  );
};

export default OtherDoc;
